import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as searchActions from '~/search2/actions';
import Helpers from '~/utils/Helpers';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import CSFilterBoxContainer from '~/search2/containers/CSFilterBoxContainer';
import Helmet from 'react-helmet';
import MetadataService from '~/utils/MetadataService';
import CvssService from '~/utils/CvssService';
const isCvss3Enabled = CvssService.isCvss3Enabled();
type SearchBarProps = {
  actions: object;
  searchDataState: object;
  navigationState: object;
};
class SearchBar extends React.Component<SearchBarProps, {}> {
  componentDidUpdate(nextProps) {
    const { searchDataState: nextSearchDataState } = nextProps;
    const { filters: nextFilters = {} } = nextSearchDataState;
    const { query: nextQuery = '' } = nextFilters;
    const { searchDataState } = this.props;
    const { filters = {}, ranFirstQuery = false, isSearchMode = false } = searchDataState;
    const { query = '' } = filters;
    const oldHash = window.location.hash.slice(1).replace(/%20/g, ' '),
      newHash = nextQuery.length > 0 ? 'query=' + _.clone(query).trim() : '_',
      inSearchBox = this.isInSearchBox();
    if (isSearchMode && Helpers.decode(newHash) !== Helpers.decode(oldHash) && ranFirstQuery) {
      let toSet = newHash.length > 0 ? '' + newHash : '_';
      this.updateHash(toSet);
    }
    if (!inSearchBox && document.getElementById('search-input')) {
      document.getElementById('search-input').value = query;
    }
    if (!this.loadedFirstQuery) {
      this.loadedFirstQuery = true;
      if (document.getElementById('search-input')) {
        document.getElementById('search-input').focus();
      }
    }
  }
  updateHash(toSet) {
    setTimeout(() => {
      browserHistory.push(
        `/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/search#${toSet.replace(
          / /g,
          '%20'
        )}`
      );
    }, 100);
  }
  isInSearchBox() {
    return document.activeElement && document.activeElement.id === 'search-input';
  }
  updateFilters = filters => {
    this.props.actions.updateFilters(filters);
  };
  updateCvssSelection = type => {
    this.props.actions.updateCvssSelection(type);
    const { searchDataState = {} } = this.props;
    const { filters = {} } = searchDataState;
    if (filters.severity) {
      // Handle situation when user has cvss2_severity selected and select
      // cvss3 inside the dropdown, then we'll update to cvss3_severity. Vice-verse
      // for cvss3 to cvss2
      const isCvss3Selected = type === 'cvss3';
      const severityKey = isCvss3Selected ? 'cvss3_severity' : 'cvss2_severity';
      this.props.actions.setFilter(severityKey, filters.severity);
    }
  };
  render() {
    const { searchDataState, navigationState = {} } = this.props;
    const {
      metadata = {},
      isBackendDown,
      isRequestingResults,
      isFiltering,
      cvss = 'cvss2',
      contents = [],
    } = searchDataState;
    const { hits: resultCount = 0 } = metadata;
    const resultCountMsg =
      Helpers.numberWithCommas(resultCount) + ' result' + (resultCount !== 1 ? 's' : '');
    const meta = MetadataService.generateSearchPageSEO(window.location.href);
    const hasVulnsInResult = contents.filter(content => content.type === 'artifact').length > 0;
    const { activeState = {} } = navigationState;
    const { navMenu = '' } = activeState;
    return (
      <div className="grid grid--full" key="search-catalog">
        <Helmet title={SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name} meta={meta} />
        <div className="grid__item col-1-1">
          <div className="grid">
            <div className="grid__item col-1-1 mt">
              <CSFilterBoxContainer
                onFilterChange={this.updateFilters}
                filters={this.props.searchDataState.filters}
                resultCount={resultCountMsg}
                isFiltering={isRequestingResults || isFiltering}
                isBackendDown={isBackendDown}
              />
            </div>
          </div>
        </div>
        {isCvss3Enabled &&
          hasVulnsInResult &&
          navMenu === 'search' &&
          (cvss === 'cvss2' ? (
            <div className="grid__item col-1-1 pl- pt--">
              Vulnerability data is based on CVSS version 2 scores. To see results based on CVSS
              version 3 scores, adjust your
              <span className="link--primary" onClick={() => this.updateCvssSelection('cvss3')}>
                {' '}
                search criteria
              </span>
              .
            </div>
          ) : (
            <div className="grid__item col-1-1 pl- pt--">
              Vulnerability data is based on CVSS version 3 scores. To see results based on CVSS
              version 2 scores, adjust your
              <span className="link--primary" onClick={() => this.updateCvssSelection('cvss2')}>
                {' '}
                search criteria
              </span>
              .
            </div>
          ))}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    searchDataState: state.searchDataState,
    navigationState: state.navigationState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(searchActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBar);
